import { render, staticRenderFns } from "./BuildingMortgage.vue?vue&type=template&id=8a122c9a&scoped=true"
import script from "./BuildingMortgage.vue?vue&type=script&lang=js"
export * from "./BuildingMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a122c9a",
  null
  
)

export default component.exports